import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from "recharts";

interface FleetExposureChartProps {
  exposure: {
    upToDate: number;
    outdated: number;
    unknown: number;
    total: number;
  };
}

const COLORS = {
  upToDate: "hsl(142, 76%, 36%)",
  outdated: "hsl(0, 84%, 60%)",
  unknown: "hsl(var(--muted-foreground))",
};

export function FleetExposureChart({ exposure }: FleetExposureChartProps) {
  const data = [
    { name: "Up to Date", value: exposure.upToDate, color: COLORS.upToDate },
    { name: "Outdated", value: exposure.outdated, color: COLORS.outdated },
    ...(exposure.unknown > 0 ? [{ name: "Unknown", value: exposure.unknown, color: COLORS.unknown }] : []),
  ].filter(d => d.value > 0);

  if (data.length === 0) {
    return (
      <div className="flex items-center justify-center h-full text-muted-foreground text-sm">
        No device data available
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={80}
          paddingAngle={3}
          dataKey="value"
        >
          {data.map((entry, index) => (
            <Cell key={index} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          contentStyle={{
            backgroundColor: "hsl(var(--popover))",
            border: "1px solid hsl(var(--border))",
            borderRadius: "8px",
          }}
          formatter={(value: number) => [`${value} devices`, ""]}
        />
        <Legend
          verticalAlign="bottom"
          iconType="circle"
          iconSize={10}
          wrapperStyle={{ fontSize: 12 }}
        />
      </PieChart>
    </ResponsiveContainer>
  );
}
